export default __webpack_public_path__ + "static/media/electrek-bike-charge-cafe.7ffa4426.svg";